import $ from 'jquery';
import { namespace } from '../../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Help visualize collisions
 */
export default class Visualizer {
    visualizations = [];

    constructor(drawHelper) {
        this.drawHelper = drawHelper;
    }

    clear() {
        this.visualizations.forEach(visualization => visualization.remove());
        this.visualizations = [];
    }

    visualizeTree(tree) {
        const rootNode = tree.getRoot();

        this.visualizeNode(rootNode);
        this.visualizeLines(rootNode);
        this.visualizePoints(rootNode);
    }

    visualizeLines(node) {
        this.drawLines(node.lines);
    }

    visualizePoints(node) {
        const points = node.lines.map(line => line.startPoint);
        this.drawPoints(points);
    }

    visualizeNode(node) {
        if (node.isLeaf()) {
            this.drawNode(node);
        }

        if (node.hasLeft()) {
            this.visualizeNode(node.getLeft());
        }
        if (node.hasRight()) {
            this.visualizeNode(node.getRight());
        }
    }

    drawPoints(points) {
        points.forEach(point => this.drawPoint(point));
    }

    drawPoint(point) {
        this.visualizations.push($(this.drawHelper.drawPoint(
            point,
            {
                stroke: 'red',
                fill: 'red',
            },
        )));
    }

    drawLines(lines) {
        lines.forEach(line => this.drawLine(line));
    }

    drawLine(line) {
        this.visualizations.push($(this.drawHelper.drawLine(
            line,
            {
                stroke: 'orange',
                fill: 'orange',
            },
        )));
    }

    drawNode(node) {
        this.visualizations.push($(this.drawHelper.drawBounds(
            node.areaBounds,
            {
                stroke: `#A0A0${node.getDepth()}0`, // 'darkcyan',
                fill: `#F0F0${node.getDepth()}0`, // 'cyan'
            },
        )));
    }
}

namespace('Ofcs.Editor.Collision');
window.Ofcs.Editor.Collision.Visualizer = Visualizer;
